import { useMemo } from "react";
import { CoordinateSet } from "@/map";
import { Polygon } from "@/polygon/types/polygon";
import { Machine } from "@/machines/types/machine.ts";

export function useLocationDetailCoordinates(machines?: Machine[] | null, selectedPolygon?: Polygon | null) {

  const basicCoordinates: CoordinateSet[] = useMemo(() => {
    return machines?.filter((machine) => machine?.last_gps?.latitude && machine?.last_gps?.longitude)
      .map((machine) => {
        return {
          name: machine.name,
          color: machine.color || "#EF4444",
          path: [
            {
              lat: machine.last_gps.latitude,
              lng: machine.last_gps.longitude,
              alt: machine.last_gps.altitude,
            },
          ],
          isActive: machine.status === "online",
        } as CoordinateSet;
      }) ?? [];
  }, [machines]);

  const polygonCoordinates: CoordinateSet[] = useMemo(() => {
    if (selectedPolygon && selectedPolygon.coordinates && selectedPolygon.coordinates.length > 0) {
      return [
        {
          name: selectedPolygon.name,
          color: "#FF0000",
          path: selectedPolygon.coordinates.map((coord) => ({
            lat: coord.latitude,
            lng: coord.longitude,
          })),
          isActive: true,
        },
      ];
    }
    return [];
  }, [selectedPolygon]);

  return { basicCoordinates, polygonCoordinates };
}
